<p-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [closable]="false"
  [showHeader]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  styleClass="tsp-dialog"
>
  <div class="tsp-panel" role="dialog" [attr.aria-label]="'app.topbar.search.title' | translate">
    <div class="tsp-input-row">
      <i class="pi tsp-input-icon" [class.pi-search]="!loading()" [class.pi-spin]="loading()" [class.pi-spinner]="loading()"></i>
      <input #queryInput
             type="text"
             class="tsp-input"
             autocomplete="off"
             [value]="query()"
             (input)="onQueryChange($any($event.target).value)"
             (keydown.arrowdown)="$event.preventDefault(); onArrowDown()"
             (keydown.arrowup)="$event.preventDefault(); onArrowUp()"
             (keydown.enter)="$event.preventDefault(); onEnter()"
             (keydown.escape)="close()"
             [placeholder]="'app.topbar.search.placeholder' | translate" />
      <button type="button" class="tsp-esc" (click)="close()">ESC</button>
    </div>

    <div class="tsp-body">
      @if (error()) {
        <p class="tsp-message tsp-message-error">{{ 'app.topbar.search.error' | translate }}</p>
      } @else if (showNoResults()) {
        <p class="tsp-message">{{ 'app.topbar.search.no_results' | translate }}</p>
      } @else {
        @for (group of displayGroups(); track group.headerKey) {
          <div class="tsp-group">
            <div class="tsp-group-header">{{ group.headerKey | translate }}</div>
            @for (item of group.items; track item.key) {
              <button type="button"
                      class="tsp-item"
                      [class.is-active]="isActive(item.flatIndex)"
                      (mouseenter)="activeIndex.set(item.flatIndex)"
                      (click)="activate(item)">
                <span class="tsp-item-icon"><i [class]="item.icon"></i></span>
                <span class="tsp-item-content">
                  <span class="tsp-item-title">
                    @if (highlight(item.title); as h) {
                      {{ h.before }}<mark>{{ h.match }}</mark>{{ h.after }}
                    }
                  </span>
                  @if (item.subtitle) {
                    <span class="tsp-item-subtitle">{{ item.subtitle }}</span>
                  }
                </span>
                @if (item.kind === 'goto') {
                  <span class="tsp-item-badge">{{ 'app.topbar.search.section_badge' | translate }}</span>
                }
              </button>
            }
          </div>
        }
      }
    </div>

    <div class="tsp-footer">
      <span class="tsp-hints">
        <span class="tsp-hint"><kbd>&uarr;&darr;</kbd> {{ 'app.topbar.search.navigate_hint' | translate }}</span>
        <span class="tsp-hint"><kbd>&crarr;</kbd> {{ 'app.topbar.search.open_hint' | translate }}</span>
        <span class="tsp-hint"><kbd>esc</kbd> {{ 'app.topbar.search.close_hint' | translate }}</span>
      </span>
      <span class="tsp-brand">{{ 'app.topbar.search.title' | translate }}</span>
    </div>
  </div>
</p-dialog>
